import { models } from '@kurtosys/ksys-app-template';

export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '064d6d3f-8366-4388-ae35-fe6f200fa2d8',
	serviceUrl: 'https://api-rel.fundpress.io',
};